import Axios, { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

import {
    ScheduleEvent,
    ScheduleEventType,
    ScheduleEventSubtype,
    TPromise,
} from "store/environments/tenants/tenant-scheduler/tenant-scheduler-types";

export const loadScheduleEvent = async (
    environmentId: string,
    tenantId: string,
    eventType: ScheduleEventType,
    subtype: ScheduleEventSubtype,
    cancelTokenSource?: CancelTokenSource
): Promise<TPromise> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.get(
        `/environments/${environmentId}/tenants/${tenantId}/scheduler/events/${eventType}/${subtype}`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};
export const updateScheduleEvent = async (
    environmentId: string,
    tenantId: string,
    scheduler: ScheduleEvent
): Promise<[string | null, number]> => {
    if (!environmentId || !tenantId || !scheduler) {
        return defaultErrorResponse;
    }

    const response = await API.put(
        `/environments/${environmentId}/tenants/${tenantId}/scheduler/events`,
        scheduler
    );

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};
